import { Controller } from 'react-hook-form';

// Card de upload do certificado de assinatura digital (.pfx/.p12) + senha.
// Diferente do ImageCardUpload: arquivo não-imagem, sem preview, com campo de senha
// e exibição de metadados (titular/validade) quando já há assinatura configurada.
function PfxCardUpload({
    temAssinatura,
    nome,
    validade,
    selecionado,
    inputRef,
    control,
    register,
    onSelect,
    onRemove,
}) {
    const validadeFmt = validade
        ? new Date(validade).toLocaleDateString('pt-BR')
        : null;

    return (
        <div className="card border-0 shadow-sm h-100 ajustes-image-card" style={{ backgroundColor: '#fafbfc' }}>
            <div className="card-body p-4">
                <div className="d-flex align-items-center mb-3">
                    <div className="rounded-circle bg-primary bg-opacity-10 px-2 py-1 me-3 ajustes-icon-circle">
                        <i className="bi bi-shield-lock text-primary"></i>
                    </div>
                    <label className="form-label mb-0 fw-semibold">Certificado de Assinatura (.pfx)</label>
                </div>

                {/* Seletor de arquivo */}
                <label
                    className={`form-control ajustes-upload-label ${selecionado ? 'border-success bg-success bg-opacity-10' : 'border-secondary'} cursor-pointer text-center py-3`}
                    onClick={() => inputRef.current?.click()}
                >
                    <i className={`bi ${selecionado ? 'bi-check-circle-fill' : 'bi-cloud-arrow-up'} me-2`}></i>
                    <span className="fw-medium">
                        {selecionado ? 'Arquivo selecionado' : (temAssinatura ? 'Trocar certificado' : 'Selecionar certificado')}
                    </span>
                </label>
                <Controller
                    control={control}
                    name="assinatura"
                    render={({ field: { onChange, onBlur, ref } }) => (
                        <input
                            type="file"
                            style={{ display: 'none' }}
                            accept=".pfx,.p12"
                            onBlur={onBlur}
                            ref={(e) => { ref(e); inputRef.current = e; }}
                            onChange={(e) => {
                                const files = e.target.files;
                                onChange(files);
                                onSelect(files && files.length > 0);
                            }}
                        />
                    )}
                />

                {/* Senha do certificado */}
                <div className="mt-3">
                    <label className="form-label fw-semibold small">Senha do certificado</label>
                    <input
                        type="password"
                        className="form-control"
                        autoComplete="new-password"
                        placeholder={temAssinatura ? '•••••••• (deixe em branco para manter)' : 'Senha do arquivo .pfx'}
                        {...register('assinatura_senha')}
                    />
                    <small className="text-muted d-block mt-1">
                        A senha é obrigatória ao enviar um novo certificado.
                    </small>
                </div>

                {/* Status / metadados da assinatura atual */}
                {temAssinatura && (
                    <div className="mt-3 pt-3 border-top">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="badge bg-success bg-opacity-10 text-success border border-success">
                                <i className="bi bi-patch-check-fill me-1"></i>Assinatura configurada
                            </span>
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={onRemove}>
                                <i className="bi bi-trash"></i>
                            </button>
                        </div>
                        {nome && (
                            <div className="small text-muted"><strong>Titular:</strong> {nome}</div>
                        )}
                        {validadeFmt && (
                            <div className="small text-muted"><strong>Válido até:</strong> {validadeFmt}</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default PfxCardUpload;
